"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  GoogleSnippet: () => GoogleSnippet,
  gaEvent: () => event,
  pageview: () => pageview,
  track: () => track,
  usePageview: () => usePageview
});
module.exports = __toCommonJS(src_exports);
var import_lodash = require("lodash");

// src/ga.tsx
var React = __toESM(require("react"));
var pageview = (url) => {
  if (window.gtag && process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS) {
    window.gtag("config", process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS, {
      page_path: url
    });
  }
};
var event = ({ action, params }) => {
  if (window.gtag && process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS) {
    window.gtag("event", action, params);
  }
};
var GoogleSnippet = () => process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("script", {
  async: true,
  src: `https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS}`
}), /* @__PURE__ */ React.createElement("script", {
  dangerouslySetInnerHTML: {
    __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS}', {
              page_path: window.location.pathname,
            });
          `
  }
})) : null;

// src/use-pageview.ts
var React2 = __toESM(require("react"));
var import_router = require("next/router");
var usePageview = () => {
  const router = (0, import_router.useRouter)();
  React2.useEffect(() => {
    const handleRouteChange = (url) => {
      pageview(url);
    };
    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events]);
};

// src/index.ts
var DEBUG_ANALYTICS = false;
var track = (event2, paramsOrCallback, callback) => {
  return new Promise(async (resolve) => {
    const ahoy = window.ahoy;
    let wasCalled = false;
    function politelyExit() {
      DEBUG_ANALYTICS && console.debug(`TRACKED: ${event2}`);
      if ((0, import_lodash.isFunction)(callback) && !wasCalled) {
        wasCalled = true;
        callback.apply(null, [event2, wasCalled]);
      }
      resolve(true);
    }
    const params = (0, import_lodash.isFunction)(paramsOrCallback) ? {} : paramsOrCallback;
    const timeout = 1250;
    if ((0, import_lodash.isUndefined)(callback) && (0, import_lodash.isFunction)(paramsOrCallback)) {
      callback = paramsOrCallback;
    }
    const store = console.error;
    console.error = () => {
    };
    setTimeout(politelyExit, timeout);
    console.error = store;
    if (ahoy && (0, import_lodash.isFunction)(ahoy.track)) {
      ahoy.track(event2, params);
    }
    if (window.fbq) {
      window.fbq("trackCustom", event2, params);
    }
    event({ action: event2, params });
    if (window.ga) {
      window.ga("send", {
        hitType: "event",
        eventAction: event2
      });
    }
    politelyExit();
  });
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  GoogleSnippet,
  gaEvent,
  pageview,
  track,
  usePageview
});
//# sourceMappingURL=index.js.map